import configureVue from "./configureVue";

export function configure(): void {
    configureVue();
}
